"use strict";
import {http} from '../../../core';
const RequestService = http.create();

export default {
    // 人员统计列表
    getList:function (params) {
        return RequestService.get("user_statistics/list",params);
    },
    // 人员统计-服务组
    getServiceGroup:function (params) {
        return RequestService.get('user_statistics/service_group/list',params)
    },
   
    // 详情
    detailList:function (params) {
        return RequestService.get("user_statistics/work_order/list",params);
    },
    // 派工统计列表
    getDispatchList:function (params) {
        return RequestService.get("statistics/score_table",params);
    },
    //oa工单工时列表
    getOaTimeList:function (params) {
        return RequestService.get("user_statistics/all_order/list",params);
    },
}
